/**
 * @generated SignedSource<<cd06aebe028a8d99e8b1e48e5029a179>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceTracking_item$data = {
  readonly pricingGuidance: {
    readonly maxAmount: {
      readonly amount: number | null;
    } | null;
    readonly minAmount: {
      readonly amount: number | null;
    } | null;
    readonly price: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "pricingGuidanceTracking_item";
};
export type pricingGuidanceTracking_item$key = {
  readonly " $data"?: pricingGuidanceTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceTracking_item"
};

(node as any).hash = "e21605b0f50ed5f1d7c89e6ca34d092e";

export default node;
